/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiTransferGroupReservationToRequeueRequestFromJSON(json) {
    return StreemApiTransferGroupReservationToRequeueRequestFromJSONTyped(json, false);
}
export function StreemApiTransferGroupReservationToRequeueRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transferToGroupName': !exists(json, 'transfer_to_group_name') ? undefined : json['transfer_to_group_name'],
    };
}
export function StreemApiTransferGroupReservationToRequeueRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transfer_to_group_name': value.transferToGroupName,
    };
}
//# sourceMappingURL=StreemApiTransferGroupReservationToRequeueRequest.js.map